import Vue from 'vue'
import Vuex from 'vuex'
import shared from './modules/shared'
import auth from './modules/auth';
import configuracoes from './modules/configuracoes'
import snackbar from './modules/snackbar'
import empresas from './modules/empresas'
import condicoesPagamento from './modules/condicoesPagamento'
import tiposDocumento from './modules/tiposDocumento'
import unidades from './modules/unidades'
import produtos from './modules/produtos'
import pedidos from './modules/pedidos'
import clientes from './modules/clientes'
import tabelasPreco from './modules/tabelasPreco'
import tiposEmail from './modules/tiposEmail'
import tiposTelefone from './modules/tiposTelefone'
import tiposEndereco from './modules/tiposEndereco'
import catalogos from './modules/catalogos'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared,
    auth,
    configuracoes,
    snackbar,
    empresas,
    condicoesPagamento,
    tiposDocumento,
    unidades,
    produtos,
    pedidos,
    clientes,
    tabelasPreco,
    tiposEmail,
    tiposTelefone,
    tiposEndereco,
    catalogos
  }
})
